const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRICE_TIER)

const PRICE_TIERS_QUERY_KEY = 'price-tiers' as const
const priceTierQueryKey = { ...useQueryKeyFactory(PRICE_TIERS_QUERY_KEY) }

export const apiPriceTiers = {
	fetchPriceTiers: async (): Promise<{ data: IMealPriceTierModel[] }> => {
		const fetchFn = async () => {
			const { data } = await apiCommon<IMealPriceTier[]>(`${groupPrefix}`, {
				method: 'GET',
			})

			return { data: data.map(PriceTier) }
		}

		const config = () => ({
			queryKey: priceTierQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<{ data: IMealPriceTierModel[] }>(config)
	},
	updatePriceTiers: async (payload: IDietPriceTierPayload[]) => {
		const { data } = await apiCommon<IMealPriceTier[]>(`${groupPrefix}`, {
			method: 'POST',
			body: { data: payload },
		})

		useQueryClientService().invalidateQueries(priceTierQueryKey.all)

		return { data: data.map(PriceTier) }
	},
}
